/**
 * SEO 配置与工具
 * 生产环境请设置 VUE_APP_SITE_URL 为实际域名，如 https://phonehash.cn
 */
export const SITE_URL = process.env.VUE_APP_SITE_URL || (typeof window !== 'undefined' ? window.location.origin : '')

/** 公共 API（HTTP v1 / MCP）基址；生产默认 https://api.phonehash.cn，本地开发设 VUE_APP_PUBLIC_API_URL=http://localhost:8083 */
export const DEFAULT_PUBLIC_API_URL = 'https://api.phonehash.cn'
export const PUBLIC_API_URL = (process.env.VUE_APP_PUBLIC_API_URL || DEFAULT_PUBLIC_API_URL).replace(/\/$/, '')

export const DEFAULT_META = {
  title: '哈希查号',
  description: '哈希查号：支持 MD5、SHA256 与国密 SM3 摘要的手机号查询与批量处理。在线解析手机号哈希，支持单个查询和 CSV 批量处理，安全可靠的数据处理服务。',
  keywords: '哈希查号,手机号Hash,手机号解密,Hash解析,MD5解密,SHA256解密,SM3,国密SM3,手机号查询,手机号反查,哈希值查询,哈希解密,批量处理',
  ogImage: ''
}

export const ROUTE_META = {
  '/single': {
    title: '单个查询 - 哈希查号',
    description: '输入 MD5 或 64 位十六进制摘要（SHA256、国密 SM3），在线查询对应手机号。'
  },
  '/batch': {
    title: '批量处理 - 哈希查号',
    description: '上传CSV文件批量解析手机号Hash，支持大量数据批量处理，每天首次前100条免费。'
  },
  '/pricing': {
    title: '价格说明 - 哈希查号',
    description: '批量查询阶梯价格说明，每天首次前100条免费，超出部分按阶梯计费，量越大越优惠。'
  },
  '/orders': {
    title: '订单列表 - 哈希查号',
    description: '查看您的订单记录和支付状态。'
  },
  '/settings/api-keys': {
    title: 'API Key 管理 - 哈希查号',
    description: '创建与管理 API Key，用于调用公共 HTTP 接口与 MCP 服务。'
  },
  '/docs/api': {
    title: 'HTTP 接口文档 - 哈希查号',
    description: '公共 hash-to-phone HTTP API 说明，含鉴权、请求示例与限流规则。'
  },
  '/docs/mcp': {
    title: 'MCP 对接文档 - 哈希查号',
    description: 'Streamable HTTP MCP 接入指南，含 Cursor、Claude Desktop 配置示例。'
  }
}
